import("./bootstrap").then(({ mount }) => {
    const localRoot = document.getElementById("end-user-ui-mfe");

    mount({
        mountPoint: localRoot as HTMLElement,
        routingStrategy: "browser"
    });
});
